
class tautHority{
    getauthority(str){
        return window.abp.auth.hasPermission(str)
        // if(Util.abp.auth.hasPermission('111')){
        //             return true;
        //         }else{
        //             return false;
        //         }
    }
}
const tauthority=new tautHority();
export default tauthority;
// export  function getauthority(str){
//     //console.log(Util.hasPermission)
//     if(abpbase.hasPermission('111')){
//         return true;
//     }else{
//         return false;
//     }
// }